import React from 'react';
import { Field } from 'redux-form';
import { required, SelectInput } from 'react-admin';

import DisplayPropertyOption from '../Helpers/DisplayPropertyOption';

const ValidateRequired = required();

type Props = {
  handlePropertyChange: any,
  item: string,
  properties: string[],
  propertyGroupIndex: number,
  propertyIndex: number,
  record: any
};

const PropertyOption = (props: Props) => (
  <div style={{ flex: '1' }}>
    {DisplayPropertyOption(props) &&
      <div style={{ paddingTop: 5 }}>
        <span style={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '0.9em' }}>Name</span><br /> {props.record.property_groups[props.propertyGroupIndex].properties[props.propertyIndex].display_name}
      </div>
    }
    {!DisplayPropertyOption(props) &&
      <Field
        choices={props.properties}
        component={SelectInput}
        label="Name"
        name={`${props.item}.name`}
        onChange={(event, name, value) => props.handlePropertyChange(event, name, value)}
        source={`${props.item}.name`}
        validate={ValidateRequired} />
    }
  </div>
);

export default PropertyOption;



// WEBPACK FOOTER //
// ./src/views/Common/Partials/PropertyGroups/PropertyOption.tsx